if (!customElements.get('infinity-load')) {
  class InfinityLoad extends HTMLElement {
    constructor() {
      super();

      this.container = this;
      this.section = this.container.closest('.section');
      this.slider = this.container.closest('.card-slider.swiper');
      this.cardProductClasses = this.slider.querySelector('card-product').className;
      this.isGroupSlider = this.slider.querySelector('.card-slider__slide').classList.contains('card-slider__slide--group');
      this.isLoading = false;

      this.initActions();
    }

    initActions() {
      this.container.closest('.card-slider').addEventListener('infinityLoad:load', () => {
        this.fetchProducts();
      });
    }
    async fetchProducts() {
      this.collectionHandle = this.container.dataset.collectionHandle;
      this.nextPageUrl = this.container.querySelector('[data-next-url]').value || undefined;

      if (this.isLoading || this.nextPageUrl === undefined) return;
      
      let url = `/collections/${this.collectionHandle}${this.nextPageUrl}&filter.v.availability=1&section_id=main-collection`;
      this.isLoading = true;
      
      try {
        fetch(url, {
          credentials: 'same-origin',
          method: 'GET'
        }).then((response) => {
          response.text().then((content) => {
            let tempElement = document.createElement('div');
            tempElement.innerHTML = content;

            let newProducts = tempElement.querySelectorAll('card-product');
            let productsContainer = this.slider.querySelector('.card-slider__wrapper');
            let markupProducts = ``;
            let slidesPerGroup = 6;
            let slide_index = 0;

            newProducts.forEach(product => {
              product.className = this.cardProductClasses;

              if(this.isGroupSlider){
                markupProducts += `${product.outerHTML}`;
                slide_index++;

                if(slide_index == slidesPerGroup){
                  productsContainer.insertAdjacentHTML('beforeend',`<div class="swiper-slide card-slider__slide card-slider__slide--group">${markupProducts}</div>` );
                  markupProducts = ``;
                  slide_index = 0;
                }
              }else{
                productsContainer.insertAdjacentHTML('beforeend',`<div class="swiper-slide card-slider__slide">${product.outerHTML}</div>` );
              }
            });

            this.isLoading = false;
            let newNextUrlElem = tempElement.querySelector('nav.pagination .pagination__prev-next--next') || undefined;

            newNextUrlElem 
            ? this.container.querySelector('[data-next-url]').value = newNextUrlElem.getAttribute('href').replace(`/collections/${this.collectionHandle}`, '/')
            : this.container.remove();

            this.slider.dispatchEvent(new CustomEvent('infinityLoad:loaded'));
          })
        });
      } catch (error) {
        this.isLoading = false;
        console.error(error);
        alert(error.message);
      }
    }
  }

  customElements.define('infinity-load', InfinityLoad);
}
